import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../features/auth/RequirePermission';
import { SettingsPage } from '../../features/settings/SettingsPage';

export const Route = createFileRoute('/_app/settings')({
  component: () => (
    <RequirePermission permission="team.manage">
      <SettingsPage />
    </RequirePermission>
  ),
});
